/** Indicates whether the current portal club team is playing in a FantasyGame*/
export enum ClubPlayingStatus {
    /** Portal club not involved in the current game */
    None = 0,
    /** Portal club playing at home */
    Home = 1,
    /** Portal club playing away */
    Away = 2,
  }
  